<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="row">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('wallets.label.auto_settlement_settings')"></div>
                </div>

                <div class="col-12 my-2">
                    <div class="custom-control custom-switch">
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="setting_status"
                                name="setting_status"
                                v-model="setting_status.value"
                        >
                        <label class="custom-control-label" for="setting_status">{{ $t('label.consider_auto_settlement_settings') }}</label>
                    </div>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="password" v-text="$t('label.wallet_password')"></label>
                    <input class="form-control" type="password" id="password" name="password" v-model="password.value">
                </div>

                <div v-for="(item, index) in form_data" :key="index">
                    <div class="row border border-success m-2 px-2 pb-4">
                        <div class="col-12">
                            <div class="text-danger ml-auto"
                                 style="cursor: pointer; width: fit-content;"
                                 @click="deleteRow(index)"
                            >
                                <i class="fas fa-trash"></i>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mb-2">
                            <label :for="`transfers.${index}.percent`" v-text="$t('label.percent')"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.percent`"
                                   :name="`transfers.${index}.percent`"
                                   type="number"
                                   v-model="form_data[index].percent"
                            >
                        </div>

                        <div class="col-12 col-md-6 mb-2">
                            <label :for="`transfers.${index}.destination_number`" v-text="$t('label.destination_number')"></label>
                            <input class="form-control transfers_destination_number"
                                   :id="`transfers.${index}.destination_number`"
                                   :name="`transfers.${index}.destination_number`"
                                   type="text"
                                   dir="ltr"
                                   v-model="form_data[index].destination_number"
                            >
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label :for="`transfers.${index}.destination_firstname`" v-text="$t('label.destination_firstname')"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.destination_firstname`"
                                   :name="`transfers.${index}.destination_firstname`"
                                   type="text"
                                   v-model="form_data[index].destination_firstname"
                            >
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label :for="`transfers.${index}.destination_lastname`" v-text="$t('label.destination_lastname')"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.destination_lastname`"
                                   :name="`transfers.${index}.destination_lastname`"
                                   type="text"
                                   v-model="form_data[index].destination_lastname"
                            >
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-5 pt-5">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center justify-content-between">
                            <button class="btn btn-primary mx-2"
                                    type="button"
                                    v-text="$t('label.add_new_record')"
                                    @click="addRow()"
                            >
                            </button>
                            <div class="d-inline-block mx-2">
                                <select id="new_shareholder"
                                        name="new_shareholder"
                                        v-model="new_shareholder"
                                        class="form-control"
                                >
                                    <option :value="null" selected disabled v-text="$t('label.add_new_shareholder')"></option>
                                    <option v-for="(shareholder, index) in shareholders"
                                            :key="index"
                                            :value="shareholder"
                                            v-text="shareholder.first_name + ' ' + shareholder.last_name"
                                    ></option>
                                </select>
                            </div>
                            <div v-if="new_shareholder !== null"
                                 class="d-inline-block mx-2"
                            >
                                <select id="new_account_number"
                                        name="new_account_number"
                                        v-model="new_account_number"
                                        class="form-control"
                                >
                                    <option :value="null" selected disabled v-text="$t('label.add_new_account_number')"></option>
                                    <option v-for="(account_number, index) in new_shareholder.account_numbers"
                                            :key="index"
                                            :value="account_number"
                                            v-text="account_number"
                                    ></option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <button class="btn btn-success ml-auto"
                                    type="submit"
                                    v-text="$t('btn.submit_changes')"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <otp-modal
            :loading="form_meta_data.submit_btn_progress"
            :message="$t('label.input_verification_code')"
            :two_factor_type="form_data.two_factor_type"
            @emitAction="setOtp"
            @sendRequest="sendRequest"        />
    </div>
</template>

<script>
    import Inputmask from 'inputmask';
    import {i18n} from "@/plugins/i18n";
    import {walletService} from "@/common/api.service";
    import Num2persian from 'num2persian';
    import otpModal from "@/components/elements/modal/otp-modal.vue";
    import {TwoFactorType} from "@/constants/TwoFactorType";
    import Axios from "axios";

    export default {
        components:{otpModal},
        data() {
            return {
                Num2persian,
                shareholders: [],
                new_shareholder: null,
                new_account_number: null,
                should_two_factor_settlement: false,
            };
        },
        watch: {
            new_account_number(value) {
                if (value === null) {
                    return;
                }

                // if last record is empty, fill it. otherwise add new record
                if (this.form_data[this.form_data.length - 1].destination_number === ''
                    && this.form_data[this.form_data.length - 1].destination_firstname === ''
                    && this.form_data[this.form_data.length - 1].destination_lastname === ''
                ) {
                    this.form_data[this.form_data.length - 1].destination_number = this.new_account_number;
                    this.form_data[this.form_data.length - 1].destination_firstname = this.new_shareholder.first_name;
                    this.form_data[this.form_data.length - 1].destination_lastname = this.new_shareholder.last_name;
                } else {
                    this.form_data.push({
                        percent: 0,
                        destination_number: this.new_account_number,
                        destination_firstname: this.new_shareholder.first_name,
                        destination_lastname: this.new_shareholder.last_name,
                    });
                }

                this.new_account_number = null;
                this.new_shareholder = null;
            },
             transfer_length() {
                setTimeout(() => {
                    this.initShebaMask();
                }, 500);
            },
        },
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {},
            },
            form_data: Array,
            password: Object,
            setting_status: Object,
        },
         computed: {
            transfer_length() {
                return this.form_data.length;
            },
        },
        mounted() {
            this.initShebaMask();
            walletService.shareholderList().then(res => {
                this.shareholders = res.data.data;
            })
            Axios.get('wallet/common?wallet_prefix=A').then(response => {
                response.data.data.forEach(wallet => {
                    if (wallet.id === this.$route.params.hashid) {
                        this.should_two_factor_settlement = wallet.should_two_factor_settlement;
                        this.form_data.should_two_factor_settlement = wallet.should_two_factor_settlement;
                    }
                })
            });
        },
        methods: {
            sendRequest(type) {
                this.form_data.two_factor_type = type;
                if (type === TwoFactorType.SMS) this.on_submit()
            },
            setOtp(data) {
                this.form_data.otp = data;
                this.$emit('settlement')
            },
            deleteRow(index) {
                if (this.form_data.length < 2) {
                    return;
                }

                this.form_data.splice(index, 1);
            },
            addRow() {
                if (this.form_data.length > 100) {
                    return;
                }

                this.form_data.push({
                    percent: 0,
                    destination_number: '',
                    destination_firstname: '',
                    destination_lastname: '',
                });
            },
            initShebaMask() {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number'));
            },
        }
    }
</script>
